import { countdownTargetDate, frontendDomain } from '../../../../utility'
import spdMitglied from '../../../../assets/image/cube/tiles/Underconstruction-04.webp'
import whatsapp from '../../../../assets/image/cube/tiles/Underconstruction-05.webp'
import kandiOverview from '../../../../assets/image/cube/tiles/Underconstruction-07.webp'
import countdown from '../../../../assets/image/cube/tiles/Underconstruction-02.webp'
import alarmMail from '../../../../assets/image/cube/tiles/Underconstruction-01.webp'
import politik from '../../../../assets/image/cube/tiles/Underconstruction-03.webp'
import { ItemList, ItemType } from '../../../UI/Cube/types'
// import spdSeite from '../../../../assets/image/cube/tiles/Underconstruction-06.webp'

const homeItems: ItemList = [
  {
    type: ItemType.IMAGE,
    src: kandiOverview,
    link: `https://kandidierende.spd.de/`,
  },
  {
    type: ItemType.IMAGE,
    src: whatsapp,
    link: 'https://www.spd.de/whatsapp/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
    openExternal: true,
  },
  {
    type: ItemType.IMAGE,
    src: countdown,
  },
  {
    type: ItemType.IMAGE,
    src: politik,
    link: `${frontendDomain}/programm`,
  },
  {
    type: ItemType.COUNTDOWN,
    targetDate: countdownTargetDate,
    src: spdMitglied,
    link: 'https://mitgliedwerden.spd.de/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
    openExternal: true,
  },
  {
    type: ItemType.IMAGE,
    src: alarmMail,
    link: `${frontendDomain}/newsalarm`,
  },
]

// const preKandiItems: ItemList = [
//   {
//     type: ItemType.IMAGE,
//     src: politik,
//     link: `${frontendDomain}/programm`,
//   },
//   {
//     type: ItemType.IMAGE,
//     src: whatsapp,
//     link: 'https://www.spd.de/whatsapp/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
//     openExternal: true,
//   },
//   {
//     type: ItemType.IMAGE,
//     src: countdown,
//   },
//   {
//     type: ItemType.IMAGE,
//     src: spdSeite,
//     link: 'https://spd.de/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
//     openExternal: true,
//   },
//   {
//     type: ItemType.COUNTDOWN,
//     targetDate: countdownTargetDate,
//     src: spdMitglied,
//     link: 'https://mitgliedwerden.spd.de/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
//     openExternal: true,
//   },
//   {
//     type: ItemType.IMAGE,
//     src: alarmMail,
//     link: `${frontendDomain}/newsalarm`,
//   },
// ]

export default homeItems
